import * as React from 'react'
import { cn } from '@/lib/utils'

export interface SectionHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode
  subtitle?: React.ReactNode
  action?: React.ReactNode
  /** Heading level — h2 (default) uses larger text, h3 uses lg. */
  as?: 'h2' | 'h3'
}

const SectionHeader = React.forwardRef<HTMLDivElement, SectionHeaderProps>(
  ({ className, title, subtitle, action, as: Heading = 'h2', ...props }, ref) => (
    <div ref={ref} className={cn('flex items-start justify-between gap-4', className)} {...props}>
      <div className="min-w-0 flex-1">
        <Heading
          className={cn(
            'font-semibold tracking-tight text-foreground',
            Heading === 'h2' ? 'text-xl' : 'text-lg',
          )}
        >
          {title}
        </Heading>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  ),
)
SectionHeader.displayName = 'SectionHeader'

export { SectionHeader }
